import { parsePropPath } from "./parsePropPath.js";
import { hasProp } from "./hasProp.js";

export function hasPath (obj: unknown, path: PropertyKey | PropertyKey[]) {
  const pathArray = parsePropPath(path);
  let result = false;
  for (const key of pathArray) {
    if (obj == null){
      break;
    }
    result = hasProp(obj, key);
    if (!result) {
      break;
    }
    obj = (obj as object)[ key ];
  }
  
  return result;
}
